import { ProgramType, type CohortContext } from './Program.types';

// MSBA cohorts that started before MSBA78 enrolled under the original MSBA name; the
// "and Applied AI" rename only applies to MSBA78+. We compare against the start_date
// timestamp directly rather than looking up `Cohort['MSBA78']` so the carve-out works
// in environments where MSBA78 hasn't been published yet.
export const MSBA_APPLIED_AI_RENAME_CUTOFF_TIMESTAMP = 1784534400; // Cohort['MSBA78'].start_date

// Canonical MSBA title strings for both sides of the rename cutoff. Exported so the
// MSBA function-form props in `ProgramTypeConfigs.ts` (and any other consumer that
// needs to reproduce these exact strings) can reuse the same values.
export const MSBA_PRE_RENAME_FULL_TITLE = 'MS in Business Analytics';
export const MSBA_POST_RENAME_FULL_TITLE = 'MS in Business Analytics and Applied AI';
export const MSBA_PRE_RENAME_LONG_TITLE = 'Master of Science in Business Analytics';
export const MSBA_POST_RENAME_LONG_TITLE = 'Master of Science in Business Analytics and Applied AI';
export const MSBA_PRE_RENAME_BUSINESS_ANALYTICS_TAIL = 'Business Analytics';
export const MSBA_POST_RENAME_BUSINESS_ANALYTICS_TAIL = 'Business Analytics and Applied AI';
export const MSBA_PRE_RENAME_ACHIEVEMENT_GRAPHIC_LINES: readonly [string, string] = [
    'Master of Science in',
    'Business Analytics',
];
export const MSBA_POST_RENAME_ACHIEVEMENT_GRAPHIC_LINES: readonly [string, string] = [
    'Master of Science in Business',
    'Analytics and Applied AI',
];

export function isPreMsbaAppliedAiRename(cohort: CohortContext): boolean {
    if (cohort.programType !== ProgramType.msba) return false;
    const ts = typeof cohort.startDate === 'number' ? cohort.startDate : Math.floor(cohort.startDate.getTime() / 1000);
    return ts < MSBA_APPLIED_AI_RENAME_CUTOFF_TIMESTAMP;
}
